import {useInvestAssistantContext} from "./ContextType";
import {Box} from "@mui/material";
import React from "react";

export function InvestAssistantStages({children}: any) {
    const {currentStage} = useInvestAssistantContext();

    return (
        <Box sx={{
            width: '100%',
            // Clip the horizontal slide transition so it stays inside the form
            // container instead of spilling out over the surrounding layout.
            overflow: 'hidden',
            // Vertical breathing room so card hover shadows/lift aren't clipped,
            // removed from layout again with a matching negative margin.
            py: '24px',
            my: '-24px',
        }}>
            {React.Children.toArray(children)[currentStage - 1]}
        </Box>
    );
}
